export { default } from './PwaInstallPrompt'
